import { Component, AfterViewInit, DoCheck } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { FileUploader } from 'ng2-file-upload';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { DeliassortService } from '../../../service/deli-assort/deli-assort.service';

const URL = 'https://foo.bar.com';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3053.component.html',
  styleUrls: ['wa3053.component.scss']
})
export class Wa3053Component implements AfterViewInit, DoCheck {
  public componentTitle = 'WA3053:配送仕分マスタアップロード';

  private ownerId: number;
  private ownerResult: any;

  private working = false;
  private height = 500;
  private production = environment.production;
  private backgroundColor: string;
  private updprogramCd = 'wa3053';

  private filetypes;

  private queryParam;

  private rowData;

  private selectUploadObjectId = undefined;

  private uploadpatterns = [
    { patternId: 1, patternName: '佐川仕分マスタ' },
    { patternId: 2, patternName: 'JP仕分マスタ' },
    { patternId: 3, patternName: '西濃仕分マスタ' },
    { patternId: 4, patternName: 'ヤマト仕分マスタ' },
    { patternId: 5, patternName: 'ヤマト配送リードタイムマスタ' },
    { patternId: 6, patternName: '福山仕分マスタ' }
  ];

  private uploader: FileUploader;
  private hasBaseDropZoneOver: boolean;
  private hasAnotherDropZoneOver: boolean;

  private response: string;

  public errorInfo: string = '';
  public selecterrorInfo: string = '';
  public error: boolean = false;
  private active: boolean = false;
  private errmsg: any = '';
  private errorList: object[] = [];

  private isSubmitButtonEnabled = false;

  constructor(
    private deliassortService: DeliassortService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogsService: DialogsService
  ) {
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }

    this.uploader = new FileUploader({
      url: URL,
      disableMultipart: true
    });

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.response = '';

    this.height = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      this.errorInfo = '';
    }
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public onFileSelected() {
    let inputElement = <HTMLInputElement>document.getElementById('fileupload');
    inputElement.value = null;
    this.errorList = [];

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      this.errorInfo = '';
    }
  }



  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    //複数対応になった場合、パラメータからAPI飛び先を振分けする
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  onupload(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
    } else {
    }
  }

  onSubmit() {
    this.errorInfo = '';
    this.errorList = [];
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    if (!this.isSubmitButtonEnabled)
      return;

    // if (this.working === true) {
    //   return;
    // }


    if (!this.selectUploadObjectId) {
      this.working = false;
      this.errorInfo = '仕分マスタを選択してください';
      return;
    }
    this.uploadFile();
  }

  uploadFile() {
    if (this.errorInfo != '') return;
    this.deliassortService
      .upload(
        this.selectUploadObjectId,
        this.uploader.queue[0]._file,
        this.uploader.queue[0].file.size,
        this.ownerId //未使用だが複数社対応を備えて
      )
      .then(outputJson => {
        if (outputJson.errormessage) {
          this.serverError(outputJson.errormessage);
        } else {
          sessionStorage.setItem('SuccessInfoMessage', 'ファイルのアップロードが完了しました。');
          this.uploader.clearQueue();
          this.working = false;
          this.errorList = [];
        }
      })
      .catch(error => {
        this.working = false;
        this.catchError(this.commonService.getErrorList(error));
      });
  }

  serverError(message) {
    this.working = false;
    this.errorInfo = message;
    return;
  }

  catchError(errorList) {
    this.working = false;
    this.errorList = errorList;
    this.errorInfo = 'アップロードでエラーが発生しました。下部のエラーメッセージを確認してください';
  }

  onDeleteAttachment(index) {
    this.errorInfo = '';
    this.uploader.removeFromQueue(this.uploader.queue[index]);
    this.errorList = [];
  }

  errchange() {
    this.errorInfo = '';

    let matchData = this.uploadpatterns.filter(function (item, index) {
      if (item.patternId == this) {
        return true;
      }
    }, this.selectUploadObjectId);

    if (matchData.length !== 0) {
      this.error = false;
      this.active = true;
    } else {
      this.error = true;
      this.active = false;
    }
  }

  ngDoCheck() {
    if (this.uploader.queue.length > 0) {
      // this.onFileSelected();
    }

    this.isSubmitButtonEnabled = this.selectUploadObjectId != undefined &&
      this.selectUploadObjectId != 'undefined' &&
      this.uploader.queue.length > 0;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3053/wa3053.component.ts